import { Trans } from '@lingui/macro';
import { observer } from 'mobx-react-lite';
import React, { FC, useState, useEffect } from 'react'
import Modal from 'react-modal';
import ReactQuill from 'react-quill';
import UserService from '../../../services/UserService';


const Feedback: FC<any> = observer(data => {
    const { fb, index } = data;

    return (
        <tr>
            <th scope="row">{index + 1}</th>
            <td>{fb['email']}</td>
            <td><ReactQuill
                value={fb['message']}
                className='react-quill'
                readOnly={true}
                theme="bubble"
            /></td>
        </tr>
    )
});


interface ModalProps {
    toggle: boolean;
    setToggle: (value: boolean) => void;
}

export const FeedbackListModal: FC<ModalProps> = observer(props => {
    const { toggle, setToggle } = props;
    const [feedbacks, setFeedbacks] = useState<[]>([]);

    const getFeedback = async () => {
        const res = await UserService.getFeedback();
        setFeedbacks(res.data.results);
    };

    useEffect(() => {
        getFeedback();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onRequestClose = () => {
        setToggle(false);
    };

    const getFB = () => feedbacks.map((fb: any, index: number) => {
        return <Feedback key={fb['id']} {...{ fb, index }} />
    });

    return (
        <Modal isOpen={toggle} onRequestClose={onRequestClose} ariaHideApp={false} className='Modal'>
            <div className="row Modal__Head d-flex">
                <div className="col">
                    <button type='button' className='btn btn-success' onClick={() => setToggle(false)}>
                        <span className="icon close" />
                        <Trans>Close</Trans>
                    </button>
                </div>
            </div>
            <form className="Modal__Body">
                <div className="form-group mb-3">
                    <table className="table table-striped">
                        <thead>
                            <tr>
                                <th scope="co-md-1">№</th>
                                <th scope="col-md-3">Отправитель</th>
                                <th scope="col-md-2">Сообщение отзыва</th>
                            </tr>
                        </thead>
                        <tbody>
                            {getFB()}
                        </tbody>
                    </table>

                </div>
            </form>
        </Modal >
    );
});